import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomerComponent } from './customer/customer.component';
import { ViewCustomerComponent } from './customer/view-customer/view-customer.component';
import { AddCustomerComponent } from './customer/add-customer/add-customer.component';
import { UpdateCustomerComponent } from './customer/update-customer/update-customer.component';
import { CustomerRoutingModule } from './customer-routing.module';
import { MaterialModule } from 'src/app/core/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule, MatDialogRef } from '@angular/material';
import { AddCustomerDialogComponent } from './customer/add-customer/add-customer-dialog/add-customer-dialog.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { AssignGroupCustomerDialogComponent } from './customer/assign-group-customer-dialog/assign-group-customer-dialog.component';
import { CustomerConfigurationComponent } from './customer/customer-configuration/customer-configuration.component';
import { ExportDataCustomerComponent } from './customer/export-data-customer/export-data-customer.component';
import { SynchronizeCustomerComponent } from './customer/synchronize-customer/synchronize-customer.component';
import { DialogSyncCustomerComponent } from './customer/dialog-sync-customer/dialog-sync-customer.component';
import { ResultSyncCustomerComponent } from './customer/result-sync-customer/result-sync-customer.component';
import { DialogAIRecognitionComponent } from './customer/dialog-ai-recognition/dialog-ai-recognition.component';

@NgModule({
  declarations: [
    CustomerComponent,
    ViewCustomerComponent,
    UpdateCustomerComponent,
    AddCustomerComponent,
    AddCustomerDialogComponent,
    AssignGroupCustomerDialogComponent,
    CustomerConfigurationComponent,
    ExportDataCustomerComponent,
    SynchronizeCustomerComponent,
    DialogSyncCustomerComponent,
    ResultSyncCustomerComponent,
    DialogAIRecognitionComponent
  ],
  imports: [
    CommonModule,
    CustomerRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    MatDialogModule,
    NgZorroAntdModule
  ],
  entryComponents: [
    AddCustomerComponent,
    ViewCustomerComponent,
    AddCustomerDialogComponent,
    AssignGroupCustomerDialogComponent,
    DialogSyncCustomerComponent,
    DialogAIRecognitionComponent,
    // UpdateCustomerComponent,
    ResultSyncCustomerComponent
  ],
  exports: [
    ResultSyncCustomerComponent
  ]
})
export class CustomerModule { }
